import 'css-chunksrc/client/scenes/workloads/wbs/tags/styles.scss';export default {
  "tags": "_tags_15s9e_1",
  "tag": "_tag_15s9e_1",
  "text": "_text_15s9e_20",
  "icon": "_icon_15s9e_28",
  "form": "_form_15s9e_34"
};